import '@app/config/sentry';
import '@app/config/chunkReload';

import { createRoot } from 'react-dom/client';

import App from 'application/Main';

import 'normalize.css';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
